import loading from "../../assets/images/Loading.gif";

const Loader = () => (
  <div className="loading-container" data-testid="loading-container" style={{ textAlign: "center" }}>
    <img src={loading} alt="Loading..." className="loading-gif" width="100px" height="100px" />
  </div>
);

export default Loader;
